module.exports = require('./jquery.wg_browser-detection-0.1.0-2013-08-27.js');
